



















































import { defineComponent, ref, computed, PropType } from '@vue/composition-api';
import { TranslitOption } from '@oare/types';
import sl from '@/serviceLocator';

export default defineComponent({
  props: {
    transliteration: {
      type: Object as PropType<TranslitOption>,
      required: true,
    },
    showEditDialog: {
      type: Boolean,
      default: false,
    },
    textUuid: {
      type: String,
      required: true,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  setup({ transliteration, showEditDialog }) {
    const store = sl.get('store');

    const red = ref(false);
    const yellow = ref(false);
    const green = ref(false);

    if (transliteration.color === 'Red') {
      red.value = true;
    } else if (transliteration.color === 'Yellow') {
      yellow.value = true;
    } else if (transliteration.color === 'Green') {
      green.value = true;
    } else if (transliteration.color === 'Yellow/Green') {
      yellow.value = true;
      green.value = true;
    } else if (transliteration.color === 'Yellow/Red') {
      yellow.value = true;
      red.value = true;
    }

    const canEditTransliteration = computed(() =>
      store.hasPermission('EDIT_TRANSLITERATION_STATUS')
    );

    const editTranslitDialog = ref(false);

    const dialogComponent = computed(() =>
      showEditDialog && canEditTransliteration.value
        ? () => import('./EditStoplightDialog.vue')
        : null
    );

    const openDialog = () => {
      if (showEditDialog && canEditTransliteration.value) {
        editTranslitDialog.value = true;
      }
    };

    return {
      red,
      yellow,
      green,
      editTranslitDialog,
      dialogComponent,
      canEditTransliteration,
      openDialog,
    };
  },
});
